import { render, staticRenderFns } from "./OctMacula.vue?vue&type=template&id=131007f4"
import script from "./OctMacula.vue?vue&type=script&lang=js"
export * from "./OctMacula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports